import React, { useRef, useState, useEffect } from "react";
import { ViewCpdAttendanceListConfig } from "./data/ViewCpdAttendance.Config";
import FinalMolGrid from "../../components/FinalMolGrid/FinalMolGrid";
import {useGetAttendanceListByCpdEventMutation,useLazyGetAttendanceListByCpdEventListQuery,useSaveCPDAttendanceMutation,} from "../../app/services/GMPCourseProvider/GMPCoursePoviderApi";
import { useNavigate, useParams } from "react-router-dom";
import { decryptAESID } from "../../utils/Encryption";
import Buttons from "../../components/ui/button/Buttons";
import SwalAlert from "../../services/swalService/SwalService";
import { getAuthProps } from "../../lib/authenticationLibrary";

const ViewCpdAttendanceList = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const molGridRef = useRef();
  const { success } = SwalAlert();
  const cpdEventId = id ? decryptAESID(id) : 0;
  const [dataSource, setDataSource] = useState([]);
  const [allRecords, setAllRecords] = useState([]);
  const [paginationRequest, setPaginationRequest] = useState({
    pageNo: 1,
    pageSize: 20,
    cpdEventId,
  });
  const [getAttendanceListByCpdEvent, { data: getAttendanceListByCpdEventData }] =useGetAttendanceListByCpdEventMutation();
  const [getAttendanceListByCpdEventList, { data: fullDataList }] =useLazyGetAttendanceListByCpdEventListQuery();
  const [saveCPDAttendance,{ isSuccess: isSuccessSave, isLoading: isLoadingSave, data: saveData },] = useSaveCPDAttendanceMutation();
  const [statusId, setSetStatusID] = useState();

  useEffect(() => {
    getAttendanceListByCpdEvent(paginationRequest);
  }, [id]);

  useEffect(() => {
    if (cpdEventId) {
      getAttendanceListByCpdEventList(cpdEventId);
    }
  }, [ id ]);

  useEffect( () => {
    if ( fullDataList && Array.isArray( fullDataList ) ){
      const updated = fullDataList.map( ( item ) =>{
        let isApproveValue = false;
        
        if ( statusId > 0  ) {
          isApproveValue = item.isApprove === true;
        }
        else {
          isApproveValue = item.remark === "Record Found" || item.isApprove === true;
        }
        return {  
          ...item,
          isApprove: isApproveValue,
          isDisabled: item.remark === "GMP Number Not Exists",
        };
      } );
      setAllRecords( updated );
    }
  }, [ fullDataList, statusId ] );


  useEffect(() => {
    if (getAttendanceListByCpdEventData?.totalCount && allRecords.length > 0) {
      setPaginationRequest((prev) => ({
        ...prev,
        totalCount: getAttendanceListByCpdEventData.totalCount,
      }));

      const startIndex = (paginationRequest.pageNo - 1) * paginationRequest.pageSize;
      const endIndex = startIndex + paginationRequest.pageSize;
      setDataSource(allRecords.slice(startIndex, endIndex));
    }
  }, [getAttendanceListByCpdEventData,allRecords,paginationRequest.pageNo,paginationRequest.pageSize,]);

  useEffect(() => {
    if (!isLoadingSave && isSuccessSave && saveData) {
      success("Attendance Approved Successfully");
      getAttendanceListByCpdEvent(paginationRequest);
    }
  }, [isLoadingSave, isSuccessSave, saveData]);

  useEffect(() => {
    if (getAttendanceListByCpdEventData?.itemList) {
      setSetStatusID(
        getAttendanceListByCpdEventData.itemList.some((item) => item.statusId > 0)
      );
    }
  }, [getAttendanceListByCpdEventData]);

  const handlePageChange = ({ pageNumber, pageSize }) => {
    setPaginationRequest((prev) => ({
      ...prev,
      pageNo: pageNumber,
      pageSize,
    }));
  };

  const handleRowSelection = (selectedRow) => {
    setAllRecords((prev) =>
      prev.map((item) =>
        item.cpdAttendanceId === selectedRow.cpdAttendanceId
          ? { ...item, isApprove: !item.isApprove }
          : item
      )
    );
  };

  const handleApprove = () => {
    let authData = getAuthProps();

    const request = {
      SaveAttendance: allRecords.map((item) => ({
        CpdAttendanceId: item.cpdAttendanceId,
        CpdEventId: item.cpdEventId,
        GMPNumber: item.gmpNumber,
        IsApprove: item.isApprove === true,
        UpdatedBy : 115,
        UpdatedAppId : authData?.adminUserId
      })),
    };

    saveCPDAttendance(request);
    setTimeout(() => {
      navigate("/attendanceSubmissionList");
    }, 2000);
  };

  const handleBack = () => {
    navigate("/attendanceSubmissionList");
  };

  return (
    <div>
      <FinalMolGrid
        ref={molGridRef}
        configuration={ViewCpdAttendanceListConfig}
        dataSource={dataSource}
        allowPagination={true}
        onPageChange={handlePageChange}
        pagination={paginationRequest}
        onHandleRowSelect={handleRowSelection}
      />
      <div className="col-md-12 mb-4 mt-4 d-flex justify-content-between align-items-center">
        <Buttons
          buttonText={"Back"}
          buttonTypeClassName="btn black-btn"
          onClick={handleBack}
        />
        <Buttons
          buttonText="Save"
          buttonTypeClassName={`btn success-btn ${statusId ? "d-none" : ""}`}
          onClick={handleApprove}
        />
      </div>
    </div>
  );
};

export default ViewCpdAttendanceList;
